import './TodaysProgram.scss'

import { useContext } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, Col, Row } from 'react-bootstrap'

import CourseContext from 'components/common/contexts/CourseContext'
import UserProgramCourse from 'components/assessment/UserProgram/UserProgramCourse'
import UserProgramPractice from 'components/assessment/UserProgram/UserProgramPractice'
import UserProgramContext from 'components/common/contexts/UserProgramContext'
import UserAssessmentModal from 'components/assessment/UserAssessmentModal'
import { navigateTo } from 'components/common/navigation'
import { ROUTE_ASSESSMENT_PROGRAM } from 'components/common/helpers/Paths'

/**
 * Today's Program component: used to display the user's program for the day
 */
export default function TodaysProgram() {
  const history = useHistory()
  const { courses, progress } = useContext(CourseContext)
  const { userProgram } = useContext(UserProgramContext)
  let todaysCourseId, firstProgram

  // If we don't have any courses return null
  if (!courses) return null

  // If we don't have a program, then don't fetch any courses
  if (userProgram) {
    try {
      // If the program is an object, use it
      firstProgram = userProgram

      // If the program is an array, use the first item
      if (Array.isArray(userProgram)) firstProgram = userProgram[0]

      todaysCourseId = firstProgram?.courses?.split(',')[0]

      if (progress) {
        // Get all courses in progress that have a start date and are not completed
        const inProgress = progress.filter(
          course => course.date_started && !course.date_completed
        )

        // If we have any courses in progress, then let's get the most recent one
        if (inProgress.length) {
          // Sort by start date and get the most recent course in progress
          const mostRecent = inProgress.sort((a, b) => {
            return new Date(b.date_started) - new Date(a.date_started)
          })[0]

          // Get the course that is most recent
          const todaysCourse = courses.find(
            course => course.id === mostRecent.course
          )

          // If we have a course, then let's set the course id
          todaysCourseId = todaysCourse?.id || todaysCourseId
        }
      }
    } catch (e) {
      console.error('error', e)
    }
  }

  return (
    <div className='todays-program mt-4' id='js-tour-user-plan'>
      <Row>
        <Col>
          <h2 className='today-title mt-0'>For You Today</h2>
        </Col>

        {/* Don't show the button if the user doesn't have a plan */}
        {userProgram && todaysCourseId && (
          <Col className='text-end'>
            <Button
              variant='light-green'
              onClick={_ => navigateTo(ROUTE_ASSESSMENT_PROGRAM, history)}
            >
              My plan
            </Button>
          </Col>
        )}
      </Row>

      {/* If we have a course, let's display it */}
      {todaysCourseId && (
        <UserProgramCourse courseId={todaysCourseId} className='my-4' />
      )}

      {/* If we don't have a program, let's prompt the user */}
      {(!userProgram || userProgram?.length < 1) && (
        <UserAssessmentModal className='my-4' />
      )}

      {firstProgram?.practices?.split(',').map((practiceKey, practiceIndex) => (
        <UserProgramPractice
          key={practiceIndex}
          type={practiceKey}
          practiceIndex={practiceIndex}
          className='my-4'
        />
      ))}
    </div>
  )
}
